import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Keyboard } from "swiper";
import "./carousel.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

export default function CustomCarousel({
  children,
  showArrows = false,
  showDots = false,
  isKeyboardEnabled = true,
  className,
  isPaused = false,
}) {
  const swiperRef = useRef(null);

  const slides = children.map((child, index) => (
    <SwiperSlide key={`slide-${index}`}>{child}</SwiperSlide>
  ));

  const pagination = {
    clickable: true,
  };

  useEffect(() => {
    if (isPaused) swiperRef.current.swiper.slideTo(0);
  }, [isPaused]);

  return (
    <div className={className}>
      <Swiper
        pagination={!isPaused && pagination}
        keyboard={{
          enabled: isKeyboardEnabled,
        }}
        modules={[Pagination, Keyboard]}
        noSwiping={isPaused}
        noSwipingClass="swiper-slide"
        ref={swiperRef}
      >
        {slides}
      </Swiper>
    </div>
  );
}
